import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { InterProvincePnlResponse } from '@/types/api';

export interface InterProvincePnlParams {
  station: string;
  start_date: string;
  end_date: string;
}

export function useInterProvincePnl(params: InterProvincePnlParams) {
  return useQuery({
    queryKey: ['interProvincePnl', params],
    queryFn: async () => {
      const res = await apiClient.get<InterProvincePnlResponse>(
        '/inter_province/pnl',
        { params }
      );
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.station && !!params.start_date && !!params.end_date,
  });
}
